import styled from '@emotion/styled';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import {
  BASE_FIELD_BACKGROUND_COLOR,
  BASIC_BORDER_COLOR,
  BASIC_BORDER_RADIUS,
  TABLE_ODD_ROW_BACKGROUND_COLOR,
} from '../../themes/tokens';

interface IStyledTableCell {
  styledBgColor?: boolean;
}

export const TableHeadCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== 'styledBgColor',
})<IStyledTableCell>`
  background-color: ${({ styledBgColor }) => styledBgColor && TABLE_ODD_ROW_BACKGROUND_COLOR};
  font-weight: 700;
`;

export const TitleWrapper = styled(Box)`
  margin-top: 48px;
  margin-bottom: 16px;
`;

export const StyledTableContainer = styled(TableContainer)`
  background-color: transparent;
  border-radius: ${BASIC_BORDER_RADIUS};
  border: 1px solid ${BASIC_BORDER_COLOR};
`;

export const StyledTable = styled(Table)`
  background-color: transparent;
`;

export const StyledTableBody = styled(TableBody)`
  background-color: transparent;
`;

export const StyledTableHead = styled(TableHead)`
  background-color: ${BASE_FIELD_BACKGROUND_COLOR};
`;

export const StyledTableRow = styled(TableRow)`
  background-color: ${BASE_FIELD_BACKGROUND_COLOR};
  &:last-child td,
  &:last-child th {
    border: 0;
  }
`;

export const StyledTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== 'styledBgColor',
})<IStyledTableCell>`
  background-color: ${({ styledBgColor }) => styledBgColor && TABLE_ODD_ROW_BACKGROUND_COLOR};
`;

export const StyledGroupTableRow = styled(TableRow)`
  background-color: ${TABLE_ODD_ROW_BACKGROUND_COLOR};
  .MuiTableCell-root {
    font-weight: bold;
    font-style: italic;
  }
`;

export const StyledTableSubtitle = styled.p`
  font-weight: bold;
  font-style: italic;
  font-size: 16px;
  margin-left: 15px;
`;
